import React, { useEffect, useRef } from 'react';
import { AccountReactivationPage as AccountReactivationPageWebApp } from 'Roblox';

function AccountReactivationPageLoader(): JSX.Element {
  const entryPointRef = useRef<HTMLDivElement | null>(null);

  // Render AccountReactivationPageWebApp webapp on mount.
  useEffect(() => {
    if (!entryPointRef.current) {
      throw new Error('Failed to find entry point element for AccountReactivationPageLoader.');
    }
    AccountReactivationPageWebApp.renderComponent(entryPointRef.current);
  }, []);

  return <div className='account-reactivation-container' ref={entryPointRef} />;
}

export default AccountReactivationPageLoader;
